import { render, staticRenderFns } from "./ListResource.vue?vue&type=template&id=d9703ec6"
import script from "./ListResource.vue?vue&type=script&lang=js"
export * from "./ListResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports